const StationGeo={
    金边:["104.916008","11.56245"],
    广州:["113.265000","23.108000"],
    深圳:["114.109000","22.544000"],
    圣保罗:["-46.636108","-23.547501"],
    伊斯坦布尔:["28.949659","41.01384"],
    香港:["114.177000","22.307000"],
    上海:["121.445000","31.213000"],
    纽约:["-73.899994","40.8"],
    阿姆斯特丹:["4.88969","52.37403"],
    旧金山:["-122.419418","37.774929"],
    曼切斯特:["-2.23743","53.480949"],
    苏黎世:["8.55","47.366669"],
    东京:["139.691711","35.689499"],
    莫斯科:["37.615555","55.75222"],
    伦敦:["-0.11511","51.527616"],
    华盛顿:["-77.036369","38.895111"],
    洛杉矶:["-118.243683","34.052231"],
    伯明翰:["-1.89983","52.481419"],
    迪拜:["55.304722","25.258169"],
    台北:["121.516000","25.040000"],
    巴黎:["2.3488","48.853409"],
    新加坡:["103.850067","1.28967"],
    马德里:["-3.70256","40.4165"],
    曼谷:["100.51667","13.75"],
    马尼拉:["120.982201","14.6042"],
    纳什维尔:["-86.784439","36.16589"],
    芝加哥:["-87.650047","41.850029"],
    法兰克福:["8.68333","50.116669"],
    赫尔辛基:["24.93545","60.169521"],
    巴塞罗那:["2.15899","41.38879"],
    阿布扎比:["54.366669","24.466669"],
    北京:["116.391000","39.904000"],
    成都:["104.071000","30.670000"],
    鄂州:["114.858000","30.411000"],
    武汉:["114.279000","30.573000"],
    宜昌:["111.281000","30.708000"],
    赤壁:["113.530000","29.430000"],
    孝感:["113.900000","30.919000"],
    咸宁:["114.271000","29.873000"],
    枝江:["111.655000","30.472000"],
    黄石:["115.101000","30.212000"],
    荆州:["112.110000","30.200000"],
    南昌:["115.88900","28.671000"],
    九江:["115.991000","29.722000"],
    昆明:["102.702000","25.051000"],
    天门:["113.029000","30.642000"],
    澳大利亚:["149.128067","-35.283459"],
    随州:["113.363000","31.709000"],
    新余:["114.924000","27.804000"],
    信阳:["114.060000","32.125000"],
    南阳:["112.527000","32.996000"],
    清远:["113.110000","23.655000"],
    通城:["113.480000","29.150000"],
    黄冈:["114.530000","30.270000"],
    楚江: ["113.99830081711247", "22.53625465531624"],
    洪湖:["113.606000","29.924000"],
    京山:["113.104000","31.078000"],
    仙桃:["113.451000","30.375000"],
    惠州:["114.398000","23.096000"],
    周口:["114.641000","33.634000"],
    长沙:["112.967000","28.197000"],
    普吉岛:["98.398102","7.89059"],
    济南:["117.009000","36.663000"],
    贵阳:["106.700000","26.572000"],
    马来西亚:["101.686531","3.1412"],
    潜江:["112.891000","30.427000"],
    赣州:["114.916000","25.832000"],
    梅州:["116.119000","24.321000"],
    荆门:["112.195000","31.031000"],
    东莞:["113.736000","23.047000"],
    杭州:["120.165000","30.319000"],
    厦门:["118.070000","24.445000"],
    株洲:["113.109000","27.863000"],
    武昌:["",""],
    岳阳:["113.095000","29.378000"],
    宁波:["121.542000","29.872000"],
    汉口:["",""],
    景德镇:["117.203000","29.293000"],
    安陆:["113.628000","31.267000"],
    泰国:["100.51667","13.75"],
    中山:["113.359000","22.528000"],
    沈阳:["123.418000","41.799000"],
    抚顺:["123.906000","41.859000"],
    襄阳:["112.096000","32.082000"],
    珠海:["113.565000","22.248000"],
    枣阳:["112.787000","32.032000"],
    邵阳:["111.255000","26.994000"],
    洛阳:["112.361000","34.671000"],
    陆丰:["115.390000","22.570000"],
    固始:["115.638000","32.170000"],
    哈尔滨:["126.645000","45.758000"],
    澳门:["113.544000","22.202000"],
    柬埔寨:["104.916008","11.56245"],
    井冈山:["114.206000","26.586000"],
    大冶:["114.885000","30.093000"],
    冷水江:["111.460000","27.679000"],
    南宁:["108.295000","22.838000"],
    十堰:["110.772000","32.619000"],
    十堰市:["110.772000","32.619000"],
    新疆:["87.585000","43.781000"],
    郴州:["112.987000","25.783000"],
    长春:["125.324000","43.871000"],
    海口:["110.343000","20.039000"],
    佛山:["113.167000","22.828000"]
}

export default StationGeo;
